export enum CompanySegment {
  // Blockforce
  BLOCKFORCE = 'blockforce',

  // Common
  FASHION_COMPANY = 'fashion_company',
  DISTRIBUTION_CENTER = 'distribution_center',
  FARM = 'farm',
  UNKNOWN = 'unknown',

  // Chain Suppliers

  // Leather
  FACTORY = 'factory',
  SUBCONTRACTOR = 'subcontractor',
  SLAUGHTERHOUSE = 'slaughterhouse',
  LEATHER_HIDE_STALL = 'leather_hide_stall',
  LEATHER_FINISHING_TANNERY = 'leather_finishing_tannery',
  LEATHER_TRADER = 'leather_trader',
  LEATHER_TANNERY = 'leather_tannery',
  WET_BLUE_TANNERY = 'wet_blue_tannery',

  // Cotton
  APPAREL_MANUFACTURER = 'apparel_manufacturer',
  FIBER_PRODUCER = 'fiber_producer',
  SPINNING_PRODUCER = 'spinning_producer',
  WEAVING_MILL = 'weaving_mill',
  TEXTILE_MANUFACTURING = 'textile_manufacturing',
  CHEMICAL_INDUSTRY = 'chemical_industry',
  MANUFACTURING = 'manufacturing',
}
